import React from "react";
import { Grid, TextField, Typography } from "@mui/material";

/**
 * Text fields for values typed when sending / upload columns.
 * variables: [{ name (what values are keyed by), label, required, default, description }]; onChange(name, value).
 */
export default function VariableInputs({ variables, values, onChange, title, errors = {} }) {
  if (!variables?.length) return null;
  return (
    <Grid container spacing={2}>
      {title && (
        <Grid item xs={12}>
          <Typography sx={{ fontWeight: "bold" }}>{title}</Typography>
        </Grid>
      )}
      {variables.map((v) => (
        <Grid item xs={12} md={6} key={v.name}>
          <TextField
            fullWidth
            size="small"
            label={`${v.label || v.name}${v.required && v.default == null ? " *" : ""}`}
            value={values?.[v.name] ?? ""}
            onChange={(e) => onChange(v.name, e.target.value)}
            error={!!errors[v.name]}
            helperText={errors[v.name] || v.description || (v.default != null ? `Default: ${v.default}` : "")}
            sx={{ backgroundColor: "#fff" }}
          />
        </Grid>
      ))}
    </Grid>
  );
}
